import React from 'react';
import { Switch } from '../../ui/switch';
import SubirImagen from './SubirImagen';
import BotonesOrden from './BotonesOrden';

const claseCampo = 'w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base text-slate-800 outline-none transition-[border-color,box-shadow] focus:border-emerald-700 focus:ring-2 focus:ring-emerald-700/20 sm:text-sm';

export default function EditorOpcion({ opcion, indice, total, onCambiar, onMover, onEliminar, testId }) {
  const set = (campo, valor) => onCambiar({ ...opcion, [campo]: valor });
  return (
    <div className={`space-y-2 rounded-xl border bg-white p-3 ${opcion.activo ? 'border-slate-200' : 'border-dashed border-slate-300 opacity-70'}`} data-testid={testId}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold text-slate-400">#{indice + 1}</span>
        <BotonesOrden indice={indice} total={total} onMover={onMover} onEliminar={onEliminar} etiqueta="opción" testId={testId} />
      </div>
      <SubirImagen url={opcion.imagen_url} onCambiar={url => set('imagen_url', url)} testId={`${testId}-imagen`} />
      <input value={opcion.titulo} onChange={e => set('titulo', e.target.value)} maxLength={80} placeholder="Título (ej. Italiano)" className={claseCampo} data-testid={`${testId}-titulo`} />
      <textarea rows={2} value={opcion.especificaciones} onChange={e => set('especificaciones', e.target.value)} maxLength={1500}
        placeholder="Descripción o especificaciones (opcional)" className={claseCampo} data-testid={`${testId}-especificaciones`} />
      <label className="flex items-center justify-between text-sm text-slate-700">
        {opcion.activo ? 'Activa' : 'Inactiva'}
        <Switch checked={opcion.activo} onCheckedChange={v => set('activo', v)} className="min-h-0 data-[state=checked]:bg-emerald-600" data-testid={`${testId}-activa`} />
      </label>
    </div>
  );
}
